import React from 'react';
import NavigationBar from '../../components/nav';
import {Container,Col,Row,Table} from 'react-bootstrap'
import Title from '../../components/utilities/other/title';
import './admin.css'
class Admin extends React.Component {
    constructor(props) {
        super(props);
        this.state ={

        }

    }
    render(){
        return (
            <div>
                <NavigationBar/>
                <Container>
                <Title>Administrator Settings</Title>
                    <Row>
                    <Table>
                        <thead>
                            <tr>
                                <th>Settings</th>
                                <th className={'right-col'}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Emtpy Database</td>
                            </tr>
                        </tbody>
                    </Table>
                    </Row>
                </Container>
            </div>
        )
    }
}

export default Admin